import { API_V2 } from './apiVersion';

export const GAME_ENDPOINTS = {
  /**
   * ========================================
   * 일반 진행 게임 조회
   * ========================================
   */
  PLAY_GAME: {
    BY_STORE: (
      storeId: number,
    ) =>
      `${API_V2}/play-games/store/${storeId}`,

    DETAIL: (
      playGameId: number,
    ) =>
      `${API_V2}/play-games/${playGameId}`,
  },

  /**
   * ========================================
   * 게임 템플릿 관리
   * ADMIN
   * ========================================
   */
  ADMIN: {
    LIST:
      `${API_V2}/admin/games`,

    CREATE:
      `${API_V2}/admin/games`,

    DETAIL: (
      gameId: number,
    ) =>
      `${API_V2}/admin/games/${gameId}`,

    BLIND: (
      gameId: number,
      level: number,
    ) =>
      `${API_V2}/admin/games/${gameId}/blinds/${level}`,

    RE_ENTRY: (
      gameId: number,
      count: number,
    ) =>
      `${API_V2}/admin/games/${gameId}/re-entries/${count}`,
  },

  /**
   * ========================================
   * 실제 진행 게임 관리
   * ADMIN
   * ========================================
   */
  ADMIN_PLAY_GAME: {
    CREATE:
      `${API_V2}/admin/play-games`,

    START: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/start`,

    PAUSE: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/pause`,

    RESUME: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/resume`,

    FINISH: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/finish`,

    /**
     * 플레이어
     */
    JOIN_USER: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players`,

    JOIN_GUEST: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/guest-players`,

    PLAYER: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}`,

    APPROVE_PLAYER: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/approve`,

    OUT_PLAYER: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/out`,

    REBUY: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/rebuy`,

    CANCEL_REBUY: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/rebuy/cancel`,

    /**
     * 얼리칩
     */
    EARLY_INCREASE: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/early/increase`,

    EARLY_DECREASE: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/early/decrease`,

    /**
     * 레벨
     */
    NEXT_LEVEL: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/levels/next`,

    PREV_LEVEL: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/levels/prev`,

    /**
     * Prize
     */
    PRIZES: (
      playGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/prizes`,

    /**
     * 결제
     */
    PAYMENT: (
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/players/${userGameId}/payment`,

    CANCEL_PAYMENT: (
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/players/${userGameId}/payment/cancel`,

    PAYMENT_MEMO: (
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/players/${userGameId}/payment/memo`,
  },
} as const;